function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 17.3242,
  width: 182.927,
  height: 182.927,
  rx: 13.7047,
  fill: "#BEDAFD"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6860_49532)"
}, /*#__PURE__*/React.createElement("rect", {
  y: 18.293,
  width: 181.708,
  height: 181.708,
  rx: 13.7047,
  fill: "#BEDAFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.2048 75.6194C1.8922 74.9791 -5.93244 124.911 -13.8992 143.936L-23.6553 198.784H200.735C200.735 188.407 177.853 91.2879 162.155 99.1791C149.692 105.444 131.346 141.97 117.586 143.936C99.4214 146.53 97.3113 111.94 86.9933 111.94C70.503 111.94 70.705 146.7 55.4451 143.937C41.105 141.34 28.0459 76.0727 17.2048 75.6194Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149.532,
  cy: 45.7008,
  r: 13.7047,
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 1.42857,
  y: 19.7215,
  width: 178.85,
  height: 178.85,
  rx: 12.2761,
  stroke: "white",
  strokeWidth: 2.85715
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6860_49532"
}, /*#__PURE__*/React.createElement("rect", {
  y: 18.293,
  width: 181.708,
  height: 181.708,
  rx: 13.7047,
  fill: "white"
})));

function SvgEmptyImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage);
export default __webpack_public_path__ + "static/media/empty-image.5d1cffde.svg";
export { ForwardRef as ReactComponent };